import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Autocomplete, Button, TextField } from '@mui/material';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFSelect, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { NewsLetterImageModal } from './news-letter-image-modal';
import { useBoolean } from 'src/hooks/use-boolean';
import { NewsLettergalleryModal } from './news-letter-gallery-modal';
import { handleErrorMessages } from 'src/services/fetching';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { useLocation, useNavigate } from 'react-router';

export default function UserNewEditForm({ currentItem }) {
    const image = useBoolean();
    const gallery = useBoolean();
    const navigate = useNavigate()
    const [ selectedMethod, setSelectedMethod ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const [ data, setData ] = useState();

    const location = useLocation();
    const row = location.state;
    console.log("check Newsletter.....>>>>>>>>>>>>>>>>>>>", row);


    const optionMethod = [
        { title: 'Manual', value: 'manual' },
        { title: 'Import from Previous', value: 'import' },
    ];
    const { enqueueSnackbar } = useSnackbar();
    const NewUserSchema = Yup.object().shape({
        // subject: Yup.string().required('Subject is required'),
        // body: Yup.string().required('Body is required'),
    });

    const defaultValues = useMemo(() => ({
        subject: row?.subject || '',
        body: row?.body || '',
    }), [ row ]);

    const methods = useForm({ resolver: yupResolver(NewUserSchema), defaultValues });
    const { reset, handleSubmit, formState: { isSubmitting } } = methods;

    useEffect(() => {
        getProductUpdates();
    }, []);
    const getProductUpdates = async (page = 1) => {
        const url = `${endpoints.admin_dashboard.product_updates.newsletter.get_list}`;
        const queryParams = new URLSearchParams({ type: "newsletter", page ,is_paginate:false }).toString();
        const data = await getRequest(`${url}?${queryParams}`);
        if (data) {
            console.log("🚀 ~ getProductUpdates ~ data:", data);
            setData(data || []);
        }
    };

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('subject', data.subject);
        formData.append('body', data.body || '');
        formData.append('type', 'newsletter');
        try {
            const response = await postRequest(
                row?.id
                    ? `${endpoints.admin_dashboard.product_updates.newsletter.post_list}/${row.id}?_method=PUT`
                    : endpoints.admin_dashboard.product_updates.newsletter.post_list,
                formData,
                true
            );
            if (response.metadata?.success) {
                navigate("/dashboard/product-updates/newsletter")
                reset();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message.body || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    })
    return (
        <>
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <Box display="flex" justifyContent="end" mb={ 2 }>
                    <Box display="flex" justifyContent="space-between" gap={ 2 }>
                        <Button
                            variant="contained"
                            onClick={ () => image.onTrue() }
                            startIcon={ <Iconify icon="material-symbols:arrow-upload-progress" /> }
                        >
                            Upload Images
                        </Button>
                        <Button
                            onClick={ () => gallery.onTrue() }
                            variant="contained"
                            startIcon={ <Iconify icon="material-symbols:gallery-thumbnail-rounded" /> }
                        >
                            Gallery
                        </Button>
                        <Button
                            onClick={ () => navigate("/dashboard/product-updates/newsletter") }
                            variant="contained"
                            startIcon={ <Iconify icon="material-symbols:arrow-back" /> }
                        >
                            Back
                        </Button>
                    </Box>
                </Box>
                <Box
                    display="grid"
                    gridTemplateColumns={ { xs: "repeat(1, 1fr)", sm: "repeat(2, 1fr)" } } // Adjusted for side-by-side layout
                    rowGap={ 1 }
                    columnGap={ 2 }
                >
                    <Box>
                        <Autocomplete
                            fullWidth
                            options={ optionMethod }
                            getOptionLabel={ (option) => option.title }
                            onChange={ (event, newValue) => setSelectedMethod(newValue?.value) }
                            renderInput={ (params) => (
                                <TextField { ...params } label="Creation Method" margin="none" />
                            ) }
                        />
                    </Box>
                    { selectedMethod === 'import' && (
                        <Box>
                            <RHFSelect
                                native
                                name="role"
                                label="Template List"
                                defaultValue="" // Default to empty value
                                InputLabelProps={ { shrink: true } }
                                onChange={ (e) => {
                                    const selectedId = e.target.value;
                                    if (selectedId === "") {
                                        methods.setValue('subject', '');
                                        methods.setValue('body', '');
                                    } else {
                                        // Find the selected item and populate fields
                                        const selectedItem = data?.find((item) => item.id.toString() === selectedId);
                                        if (selectedItem) {
                                            methods.setValue('subject', selectedItem.subject);
                                            methods.setValue('body', selectedItem.body);
                                        }
                                    }
                                } }
                            >
                                <option value="">Select</option>
                                { data?.map((item) => (
                                    <option key={ item.id } value={ item.id }>
                                        { item.subject }
                                    </option>
                                )) }
                            </RHFSelect>
                        </Box>
                    ) }

                </Box>
                <Box
                    rowGap={ 1 }
                    columnGap={ 2 }
                    mt={ 2 }
                    display="grid"
                    gridTemplateColumns={ { xs: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)' } }
                >
                    <RHFTextField
                        name="subject"
                        label="Subject"
                        InputLabelProps={ { shrink: true } }
                    />
                    <RHFTextField
                        name="body"
                        label="Body"
                        multiline
                        rows={ 15 }
                        InputLabelProps={ { shrink: true } }
                    />

                </Box>

                <Stack alignItems="flex-end" sx={ { mt: 3 } }>
                    <LoadingButton type="submit" variant="contained" loading={ isSubmitting }>
                        { row?.id ? 'Update' : 'Save' }
                    </LoadingButton>
                </Stack>
            </FormProvider>
            {/* Modals */ }
            <NewsLetterImageModal open={ image.value } onClose={ image.onFalse } />
            <NewsLettergalleryModal open={ gallery.value } onClose={ gallery.onFalse } />
        </>
    );
}

UserNewEditForm.propTypes = {
    currentItem: PropTypes.object,
};
